var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "_eui-highcharts",
      class: {
        "-inaktiverad": _vm.skaVaraInaktiverad,
        "-osynlig": _vm.skaVaraOsynlig
      },
      attrs: { id: _vm.uniktId, disabled: _vm.skaVaraInaktiverad }
    },
    [
      _c("div", {
        ref: "diagramcontainern",
        staticClass: "_eui-highcharts_diagramcontainern"
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }